import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UPSISubscriptionService {

    constructor(private http: HttpClient) { }

    /**
     * Get UPSI Subscription configuration for a company
     * @param companyId (optional) - if not provided, uses company from header
     */
    getUPSISubscriptionConfig(companyId?: string): Promise<any> {
        const url = companyId 
            ? `${environment.clientUrl}upsiSubscriptionConfig/get/${companyId}`
            : `${environment.clientUrl}upsiSubscriptionConfig/get`;
        
        return this.http.get(url)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error fetching UPSI subscription config:', error);
                return Promise.reject(error);
            });
    }

    /**
     * Save or Update UPSI Subscription configuration
     * @param data { CompanyId, SubscriptionType }
     */
    saveOrUpdateUPSISubscriptionConfig(data: any): Promise<any> {
        return this.http.post(`${environment.clientUrl}upsiSubscriptionConfig/save`, data)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error saving UPSI subscription config:', error);
                return Promise.reject(error);
            });
    }

    /**
     * Toggle UPSI Subscription type (Main <-> Lite)
     * @param data { CompanyId }
     */
    toggleUPSISubscription(data: any): Promise<any> {
        return this.http.post(`${environment.clientUrl}upsiSubscriptionConfig/toggle`, data)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error toggling UPSI subscription:', error);
                return Promise.reject(error);
            });
    }

    /**
     * Get all UPSI subscription configurations (Admin view)
     */
    getAllUPSISubscriptionConfigs(): Promise<any> {
        return this.http.get(`${environment.clientUrl}upsiSubscriptionConfig/getAll`)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error fetching all UPSI subscription configs:', error);
                return Promise.reject(error);
            });
    }
}

